import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppLinkService } from '../../core/services/app-link.service';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-email-verification-page',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './email-verification-page.component.html',
  styleUrl: './email-verification-page.component.scss',
})
export class EmailVerificationPageComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private readonly auth = inject(AuthService);
  private readonly appLinks = inject(AppLinkService);

  private routeSubscription?: Subscription;

  loading = true;
  successMessage = '';
  errorMessage = '';
  readonly isAndroidDevice = this.appLinks.isAndroidDevice();
  readonly playStoreUrl = this.appLinks.playStoreUrl;
  readonly openAppUrl = this.appLinks.buildAuthAppLink('email-verification');

  ngOnInit(): void {
    this.routeSubscription = this.route.queryParamMap.subscribe((params) => {
      const token = params.get('token')?.trim() ?? '';
      this.loading = true;
      this.successMessage = '';
      this.errorMessage = '';

      if (!token) {
        this.loading = false;
        this.errorMessage = 'Le lien de validation est invalide ou incomplet.';
        return;
      }

      this.auth.confirmEmailVerification(token).subscribe({
        next: (response) => {
          this.loading = false;
          this.successMessage =
            response.message ?? 'Votre adresse email a bien été validée.';
        },
        error: (error) => {
          this.loading = false;
          this.errorMessage = this.resolveError(error);
        },
      });
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }

  private resolveError(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
      const backendMessage =
        typeof error.error === 'object' && error.error
          ? (error.error as { message?: string }).message
          : undefined;
      return backendMessage ?? 'Ce lien de validation est invalide ou expiré.';
    }

    if (error instanceof Error && error.message) {
      return error.message;
    }

    return 'Ce lien de validation est invalide ou expiré.';
  }
}
